import esriId from "@arcgis/core/identity/IdentityManager";
import OAuthInfo from "@arcgis/core/identity/OAuthInfo";
import { setAsyncError } from "../utils/helper";
// setDefaultOptions({ css: true });

export const createOAuth = async (setError) => {
  try {
    const info = new OAuthInfo({
      appId: "NUbgskpZPx5um9Wc",
      popup: false,
    });
    esriId.registerOAuthInfos([info]);
    // esriId
    //   .checkSignInStatus(info.portalUrl + "/sharing")
    //   .then(() => {
    //     const portal = new Portal({
    //       authMode: "immediate",
    //     });

    //     portal.load().then(() => {
    //       console.log(portal.user);
    //       // store.dispatch(setAuthUser(portal.user));
    //     });
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //     // store.dispatch(resetAuthUser());
    //   });
    return info;
  } catch (err) {
    setAsyncError(err, setError);
  }
};
